// © 2015-2021 WDNA - All Rights Reserved

import { LayoutSkin, LayoutConfig } from 'wdna-components/lib/layout/types';

export const COMMON_CONFIG: LayoutConfig = {
  menu_speed: 200,
  smartSkin: 'smart-style-entropy',
  buildUrl: 'build',
  maxMobileWidth: 979,
  wiki: {
    url: new URL('https://wdna.sensorpatrol.com/wiki/doku.php'),
    user: 'guest',
    pass: 'WDNA2021IoT',
  }
};

export const COMMON_SKINS: LayoutSkin[] = [
  {
    label: 'Dark',
    name: 'smart-style-entropy',
    logo: 'assets/img/logos/wdna_white.png',
    class: 'btn btn-block btn-xs txt-color-white margin-right-5',
    style: {
      backgroundColor: '#4E463F',
      loadingIntroColor: '#d7f1c1',
      fontColor: '#fff',
      leftAxisColor: 'rgba(255,255,255,1)',
      rightAxisColor: 'rgba(255,255,255,0.5)',
      gridLineColor: 'rgba(255,255,255,0.5)',
    },
  },
  {
    label: 'Light',
    name: 'smart-style-entropy-light',
    logo: 'assets/img/logos/wdna_light_skin_sm.png',
    class: 'btn btn-block btn-xs txt-color-white margin-right-5',
    style: {
      backgroundColor: '#4E463F',
      loadingIntroColor: '#597477',
      fontColor: '#3e5f63',
      leftAxisColor: '#3e5f63',
      rightAxisColor: '#3e616599',
      gridLineColor: '#3e616599',
    },
  },
  {
    label: 'Pink',
    name: 'smart-style-entropy-pink',
    logo: 'assets/img/logos/wdna_white.png',
    class: 'btn btn-block btn-xs txt-color-white margin-right-5',
    style: {
      backgroundColor: '#4E463F',
      loadingIntroColor: '#b71573',
      fontColor: '#fff',
      leftAxisColor: 'rgba(255,255,255,1)',
      rightAxisColor: 'rgba(255,255,255,0.5)',
      gridLineColor: 'rgba(255,255,255,0.5)',
    },
  },
  {
    label: 'Gold',
    name: 'smart-style-entropy-gold',
    logo: 'assets/img/logos/wdna_white.png',
    class: 'btn btn-block btn-xs txt-color-white margin-right-5',
    style: {
      backgroundColor: '#4E463F',
      loadingIntroColor: '#ffaf03',
      fontColor: '#fff',
      leftAxisColor: 'rgba(255,255,255,1)',
      rightAxisColor: 'rgba(255,255,255,0.5)',
      gridLineColor: 'rgba(255,255,255,0.5)',
    },
  },
];
